<template>
  <div v-if="show" class="fub-banner">
    <i class="fa fa-exclamation-triangle fub-icon" />
    <span class="fub-text">
      <strong>Medical history overdue</strong><span v-if="dueDate"> (due {{ formatDate(dueDate) }})</span>.
      <span class="fub-sub">{{ reminderText }}</span>
    </span>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'FormUpdateBadge',
  props: {
    siteId: { type: String, required: true },
    patNum: { type: [String, Number], required: true },
  },
  data() {
    return { show: false, dueDate: null, lastReminder: null };
  },
  computed: {
    reminderText() {
      if (!this.lastReminder || !this.lastReminder.sentAt) return 'No reminder sent yet.';
      const when = this.formatDate(this.lastReminder.sentAt);
      const ch = this.lastReminder.channel === 'EMAIL' ? 'Email' : 'SMS';
      if (this.lastReminder.status === 'failed') return `Reminder could not be sent (${ch}) on ${when}.`;
      return `Reminder sent ${when} via ${ch}.`;
    },
  },
  watch: {
    patNum: 'load',
  },
  mounted() {
    this.load();
  },
  methods: {
    formatDate(d) { return d ? moment(d).format('MMM D, YYYY') : ''; },
    async load() {
      this.show = false;
      if (!this.siteId || this.patNum == null || this.patNum === '') return;
      const res = await this.$store.dispatch('forms/getFormUpdateStatus', { siteID: this.siteId, patNum: this.patNum });
      const data = res && res.data;
      if (data && data.enabled && data.isOverdue) {
        this.dueDate = data.dueDate;
        this.lastReminder = data.lastReminder;
        this.show = true;
      }
    },
  },
};
</script>

<style scoped>
.fub-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 10px;
  font-size: 12.5px;
  line-height: 1.4;
}
.fub-icon { color: #d97706; }
.fub-sub { color: #a16207; }
</style>
